import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import styles from "./addBilling.module.css";
import { toast } from "react-toastify";
import api from "../../../../Website/utils/api";
import { CloseCircle } from "../../../../Svg";

const AddVendorBilling = ({ onClose, id }) => {
  // Formik setup
  const {
    errors,
    values,
    handleChange,
    touched,
    isSubmitting,
    handleBlur,
    handleSubmit,
    resetForm,
  } = useFormik({
    initialValues: {
      quantity: "",
      projectName: "",
      application: "",
      endUser: "",
    },
    validationSchema: Yup.object({
      quantity: Yup.string().required("Quantity is required"),
      projectName: Yup.string().required("Project name is required"),
      application: Yup.string().required("Application is required"),
      endUser: Yup.string().required("End user is required"),
    }),
    onSubmit: async (values) => {
      console.log(values);

      try {
        const datas = {
          id,
          values
        }
        const { data } = await api.sampleRequest(datas)
        if (data) {
          toast.success('Sample request sent successfully')
        }
      } catch (err) {
        console.log(err);
        toast.error(err?.response?.data?.message || 'some error occurs')
      }
    },
  });


  return (
    <div className={styles.popupOverlay}>
      <div className={styles.popupContent}>
        <button className={styles.popupcloseButton} onClick={onClose}>
          <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 28.4375C7.5875 28.4375 1.5625 22.4125 1.5625 15C1.5625 7.5875 7.5875 1.5625 15 1.5625C22.4125 1.5625 28.4375 7.5875 28.4375 15C28.4375 22.4125 22.4125 28.4375 15 28.4375ZM15 3.4375C8.625 3.4375 3.4375 8.625 3.4375 15C3.4375 21.375 8.625 26.5625 15 26.5625C21.375 26.5625 26.5625 21.375 26.5625 15C26.5625 8.625 21.375 3.4375 15 3.4375Z" fill="#A4A4A4" />
            <path d="M11.4627 19.4742C11.2252 19.4742 10.9877 19.3867 10.8002 19.1992C10.4377 18.8367 10.4377 18.2367 10.8002 17.8742L17.8752 10.7992C18.2377 10.4367 18.8377 10.4367 19.2002 10.7992C19.5627 11.1617 19.5627 11.7617 19.2002 12.1242L12.1252 19.1992C11.9502 19.3867 11.7002 19.4742 11.4627 19.4742Z" fill="#A4A4A4" />
            <path d="M18.5377 19.4742C18.3002 19.4742 18.0627 19.3867 17.8752 19.1992L10.8002 12.1242C10.4377 11.7617 10.4377 11.1617 10.8002 10.7992C11.1627 10.4367 11.7627 10.4367 12.1252 10.7992L19.2002 17.8742C19.5627 18.2367 19.5627 18.8367 19.2002 19.1992C19.0127 19.3867 18.7752 19.4742 18.5377 19.4742Z" fill="#A4A4A4" />
          </svg>
        </button>
        <div className={styles.popuptitle}>Add New Billing Address</div>

        <form onSubmit={handleSubmit} className={styles.qrForm}>
          <div className={styles.hrLine}></div>
          <div className={styles.qrForminputMain}>
            <div className={styles.loginFormRow1}>
              <div className={styles.loginInputGroup}>
                <label>Factory Units</label>
                <select
                  name="Factory Units"
                  className={styles.selectField}
                >
                  <option value="">Select</option>
                  <option value="Unit 1">Unit 1</option>
                  <option value="Unit 2">Unit 2</option>
                </select>
                <div className={styles.error}></div>
              </div>
              <div className={styles.loginInputGroup2}>
                <label>Street Address</label>
                <input
                  type="text"
                  name="billingAddress.streetAddress"
                  placeholder="Enter street address"
                />
              </div>
            </div>
            <div className={styles.loginFormRow2}>
              <div className={styles.loginInputGroup}>
                <label>Country / Region</label>
                <select
                  name="billingAddress.country"
                  className={styles.selectField}
                >
                  <option value="">Select</option>
                  <option value="">
                  </option>
                </select>
              </div>

              <div className={styles.loginInputGroup}>
                <label>State</label>
                <select
                  name="billingAddress.state"
                  className={styles.selectField}
                >
                  <option value="">Select</option>
                  <option value="">Select</option>
                </select>

              </div>

              <div className={styles.loginInputGroup}>
                <label>Street Address</label>
                <input
                  type="text"
                  name="billingAddress.streetAddress"
                  placeholder="Enter street address"
                />
              </div>
            </div>
            <button className={styles.savechanges}>Save address</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddVendorBilling;
